/*
 * @Author: your name
 * @Date: 2020-11-09 17:00:18
 * @LastEditTime: 2021-02-25 14:52:12
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \aiot-design\src\common\components\locale\zh_CN.js
 */
const localeValues = {
  AIOTTable: {
    total: "共{total}条",
    tableIndex: "序号"
  },
  button: {
    add: '新增'
  },

  productTags: {
    delete: '刪除',
    addBtnTxt: '新增标签',
    placeholder: {
      key: '请输入标签key',
      value: '请输入标签value'
    }
  },
  UploadImage: {
    delete: '刪除',
    typeError: '图片类型错误！',
    sizeError: '图片大小错误！',
    title: '图片',
    clickUpload: '点击上传',
    tip1: '仅支持',
    tip2: '格式',
    tip3: '大小为',
    tip4: '以内'
  },
  Message: {
    ok: '确认',
    cancel: '取消'
  },
  noData: {
    content: '暂时没有数据哦~'
  }
}
export default localeValues;
